import { get, post, remove } from "./base";

export function getProjectGroups(projectId, groupId, onSuccess, onError) {
  let params = {};
  if (projectId != null) {
    params.project_id = projectId;
  }
  if (groupId != null) {
    params.group_id = groupId;
  }

  get(
    "/api/type_curve/dca/group/",
    params,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function saveProjectGroups(
  projectId,
  projectGroups,
  onSuccess,
  onError
) {
  post(
    "/api/type_curve/dca/group/",
    {
      project_id: projectId,
      project_groups: projectGroups,
    },
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    },
    true
  );
}

export function deleteProjectGroups(projectId, groupIds, onSuccess, onError) {
  let params = {};
  if (projectId != null) {
    params.project_id = projectId;
  }
  if (groupIds != null) {
    params.group_ids = groupIds;
  }

  remove(
    "/api/type_curve/dca/group/",
    params,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function getGroupWells(groupId, onSuccess, onError) {
  let params = {};
  if (groupId != null) {
    params.group_id = groupId;
  }
  get(
    "/api/type_curve/group_well/",
    params,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function saveGroupWells(groupId, wellIds, onSuccess, onError) {
  post(
    "/api/type_curve/group_well/",
    { group_id: groupId, well_uwis: wellIds },
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    },
    true
  );
}

export function deleteGroupWells(groupId, wellIds, onSuccess, onError) {
  let params = {};
  params.group_id = groupId;
  if (wellIds != null) {
    params.well_uwis = wellIds;
  }

  remove(
    "/api/type_curve/group_well/",
    null,
    params,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function removeGroupWells(groupId, wellIds, onSuccess, onError) {
  let params = {};
  params.group_id = groupId;
  if (wellIds != null) {
    params.well_uwis = wellIds;
  }

  remove(
    "/api/type_curve/group_well/",
    params,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    },
    true
  );
}

export function getProjectClusters(projectId, clusterId, onSuccess, onError) {
  let params = {};
  if (projectId != null) {
    params.project_id = projectId;
  }
  if (clusterId != null) {
    params.cluster_id = clusterId;
  }

  get(
    "/api/type_curve/dca/cluster/",
    params,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function saveProjectClusters(
  projectId,
  inputParams,
  projectClusters,
  action,
  onSuccess,
  onError
) {
  let postData = {
    project_id: projectId,
    input_params: inputParams,
    project_clusters: projectClusters,
  };
  if (action) {
    postData.action = action;
  }
  post(
    "/api/type_curve/dca/cluster/",
    postData,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    },
    true
  );
}

export function deleteProjectClusters(
  projectId,
  clusterIds,
  onSuccess,
  onError
) {
  let params = {};
  if (projectId != null) {
    params.project_id = projectId;
  }
  if (clusterIds != null) {
    params.cluster_ids = clusterIds;
  }

  remove(
    "/api/type_curve/dca/cluster/",
    params,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function getClusterWells(clusterId, onSuccess, onError) {
  let params = {};
  if (clusterId != null) {
    params.cluster_id = clusterId;
  }
  get(
    "/api/type_curve/cluster_well/",
    params,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function saveClusterWells(clusterId, wellIds, onSuccess, onError) {
  post(
    "/api/type_curve/cluster_well/",
    { cluster_id: clusterId, well_uwis: wellIds },
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    },
    true
  );
}

export function deleteClusterWells(clusterId, wellIds, onSuccess, onError) {
  let params = {};
  params.cluster_id = clusterId;
  if (wellIds != null) {
    params.well_uwis = wellIds;
  }

  remove(
    "/api/type_curve/cluster_well/",
    null,
    params,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function getMLInput(data, onSuccess, onError) {
  get(
    "/api/type_curve/ml_input/",
    { project_id: data.project_id },
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function saveMLInput(data, onSuccess, onError) {
  post(
    "/api/type_curve/ml_input/",
    data,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    },
    true
  );
}

export function getDcaRecommends(data, onSuccess, onError) {
  post(
    "/api/type_curve/dca/recommend/",
    data,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function getDcaUserTuneData(data, onSuccess, onError) {
  post(
    "/api/type_curve/dca/usertune/",
    data,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function getMLData(data, onSuccess, onError) {
  post(
    "/api/type_curve/get_ml/",
    data,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}

export function getPerformance(data, onSuccess, onError) {
  post(
    "/api/type_curve/performance/",
    data,
    null,
    {},
    (res) => {
      onSuccess(res.data);
    },
    (error) => {
      console.error(error);
      onError(error);
    }
  );
}
